var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "box-seller-registered-info" }, [
    _c("div", { staticClass: "item" }, [
      _c("div", { staticClass: "name" }, [_vm._v("国")]),
      _vm._v(" "),
      _c("div", { staticClass: "value" }, [
        _vm._v(_vm._s(_vm.seller.countryName))
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "item" }, [
      _c("div", { staticClass: "name" }, [
        _vm._v("インボイス登録番号（JCT番号）")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "value" }, [
        _vm._v(_vm._s(_vm.getInvoiceRegistrationNumber(_vm.seller)))
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "item" }, [
      _c("div", { staticClass: "name" }, [_vm._v("法人・個人")]),
      _vm._v(" "),
      _c("div", { staticClass: "value" }, [
        _vm._v(_vm._s(_vm.seller.corporateKbnStr))
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "item" }, [
      _c("div", { staticClass: "name" }, [_vm._v("統一社会信用番号")]),
      _vm._v(" "),
      _c("div", { staticClass: "value" }, [
        _vm._v(_vm._s(_vm.seller.unifiedSocialCreditIdentifier))
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "item" }, [
      _c("div", { staticClass: "name" }, [_vm._v("[担当]屋号")]),
      _vm._v(" "),
      _c("div", { staticClass: "value" }, [
        _vm._v(_vm._s(_vm.seller.companyName))
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "item" }, [
      _c("div", { staticClass: "name" }, [
        _vm._v("[担当]屋号フリガナ、または英字")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "value" }, [
        _vm._v(_vm._s(_vm.seller.companyNameEiji))
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "item" }, [
      _c("div", { staticClass: "name" }, [_vm._v("[担当]担当者氏名")]),
      _vm._v(" "),
      _c("div", { staticClass: "value" }, [
        _vm._v(_vm._s(_vm.seller.sellerName))
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "item" }, [
      _c("div", { staticClass: "name" }, [
        _vm._v("[担当]担当者氏名フリガナ、または英字")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "value" }, [
        _vm._v(_vm._s(_vm.seller.sellerNameEiji))
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "item" }, [
      _c("div", { staticClass: "name" }, [_vm._v("[担当]郵便番号")]),
      _vm._v(" "),
      _c("div", { staticClass: "value" }, [_vm._v(_vm._s(_vm.seller.zipCode))])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "item" }, [
      _c("div", { staticClass: "name" }, [_vm._v("[担当]地域")]),
      _vm._v(" "),
      _c("div", { staticClass: "value" }, [
        _vm._v(_vm._s(_vm.seller.stateName))
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "item" }, [
      _c("div", { staticClass: "name" }, [_vm._v("[担当]住所")]),
      _vm._v(" "),
      _c("div", { staticClass: "value" }, [_vm._v(_vm._s(_vm.seller.address))])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "item" }, [
      _c("div", { staticClass: "name" }, [_vm._v("[担当]建物名")]),
      _vm._v(" "),
      _c("div", { staticClass: "value" }, [
        _vm._v(_vm._s(_vm.seller.addressBuilding))
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "item" }, [
      _c("div", { staticClass: "name" }, [_vm._v("[担当]電話番号")]),
      _vm._v(" "),
      _c("div", { staticClass: "value" }, [_vm._v(_vm._s(_vm.seller.telNo))])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5304149c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5304149c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/setting/userRegisteredInfo/ChinaIndividual.vue
// module id = null
// module chunks = 